import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiHome, FiUsers, FiFileText, FiMessageCircle, FiSettings } from "react-icons/fi";
import "./ProviderBottomNav.scss";

function tabIsActive(pathname, tabPath) {
  return pathname === tabPath || pathname.startsWith(`${tabPath}/`);
}

export default function ProviderBottomNav({ basePath }) {
  const { pathname } = useLocation();

  const tabs = [
    { to: `${basePath}-bids`, label: "Bids", icon: FiHome },
    { to: `${basePath}-confirmed-patients`, label: "Patients", icon: FiUsers },
    { to: `${basePath}-appointments`, label: "Visits", icon: FiFileText },
    { to: `${basePath}-chats`, label: "Chat", icon: FiMessageCircle },
    { to: `${basePath}-settings`, label: "Settings", icon: FiSettings },
  ];

  return (
    <nav className="provider-bottom-nav" aria-label="Provider mobile navigation">
      <div className="provider-bottom-nav__inner">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = tabIsActive(pathname, tab.to);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={`provider-bottom-nav__item${active ? " provider-bottom-nav__item--active" : ""}`}
            >
              <span className="provider-bottom-nav__icon-wrap" aria-hidden>
                <Icon className="provider-bottom-nav__icon" strokeWidth={2.2} />
              </span>
              <span className="provider-bottom-nav__label">{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
